import { useIsUserHaveRole } from 'hooks/use-is-user-have-role';
import { USER_ROLES } from '../../../constants';

export const useVehicleDetailIsDisableEditMode = () => {
  const disableForRoles = useIsUserHaveRole(USER_ROLES.driver.id);

  return { isDisableEditMode: disableForRoles };
};
